

export const PDF_LINKS = {
    WORKSHOP: 'https://aikosh.indiaai.gov.in/cdn/documents/Call_for_Proposal_AIKosh_University_Engagement_Programme_final_v2.pdf',
};